import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type AccordionProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
}>;

export function Accordion({ props }: AccordionProps) {
  return (
    <ul className="m-0 list-none p-0" data-testid="accordion">
      <StructuredContentRenderer doc={props.children} />
    </ul>
  );
}
